module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9918a0206cbd34617d1e61ca58357076.png";